import Dropdown from './Dropdown';
import Toggle from './Toggle';
import InputNumber from './InputNumber';

export default {
  [Dropdown.name]: Dropdown,
  [Toggle.name]: Toggle,
  [InputNumber.name]: InputNumber,
}
